<script lang="ts">
  import dayjs from 'dayjs';
  import { ResponsiveVars, TwistBox, TwistDivider, TwistGrid, TwistGridItem } from '@twist/core';
  import { BGMode } from '$components/News/Background/BackgroundGradient.svelte';
  import type { LegalLandingPage } from '$lib/sanity/schemas';
  import Container from '../News/Container.svelte';
  import LegalPageSection from './LegalPageSection.svelte';
  import LegalPageHeader from './LegalPageHeader.svelte';
  import { type ContentSourceMap } from '@sanity/svelte-loader';

  export let document: LegalLandingPage;
  export let sourceMap: ContentSourceMap | undefined = undefined;

  $: headerTitle = document.header.title.split('Company Policies').join('<br />Company Policies');

  const responsiveVars = new ResponsiveVars()
    .addFluid('font-size', [
      ['min', 14],
      ['lg', 'max', 14, 16],
      ['max', 16]
    ])
    .toCSS();
</script>

<LegalPageHeader title={headerTitle} bg={document.header.bgColor} {sourceMap} />

<div
  class={responsiveVars}
  data-background
  data-bgmode={BGMode.DOUBLE}
  data-bgcolor1={document.bgColor}
  data-bgcolor2={document?.header?.bgColor}
>
  <Container>
    <TwistGrid>
      <TwistGridItem
        colStart={{ min: 1, lg: 1 }}
        colSpan={{ min: 4, lg: 3 }}
        rowStart={{ min: 1, lg: 1 }}
        rowSpan={{ min: 1, lg: 1 }}
      >
        {#if document.publishedDate}
          <TwistBox
            marginTop={[
              ['min', 80],
              ['lg', 'max', 80, 152],
              ['max', 152]
            ]}
          >
            <div class="publishedSection">
              <TwistDivider thickness="1px" margin={0} />
              <p class="published">Published</p>
              <p class="publishedDate">{dayjs(document.publishedDate).format('MMMM DD, YYYY')}</p>
            </div>
          </TwistBox>
        {/if}
      </TwistGridItem>
      <TwistGridItem
        colStart={{ min: 1, lg: 6 }}
        colSpan={{ min: 4, lg: 6 }}
        rowStart={{ min: 2, lg: 1 }}
        rowSpan={{ min: 1, lg: 1 }}
      >
        {#each document.countries as country, countryIndex}
          <LegalPageSection document={country} {sourceMap} path={['countries', countryIndex]} />
        {/each}
      </TwistGridItem>
    </TwistGrid>
  </Container>
</div>

<style lang="scss">
  p {
    color: var(--twist-color-gray-100);
    font-size: var(--font-size);
    line-height: 1.2;

    &.published {
      font-family: var(--font-family-primary);
      font-weight: 600;
      padding: 16px 0 8px;
    }

    &.publishedDate {
      font-family: var(--font-family-secondary);
      font-weight: 500;
    }
  }
</style>
